<template>
    <div class="col-12">
        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"><strong>Select an Option</strong>
            </h3>
            <p class="text-muted fw-light mt-4">Please note every account creation request made on this platform
                requires a deposit through EcoCash.</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row mb-5">
                    <div class="col-sm-6 mb-3">
                        <div class="card card-shadow">
                            <div class="card-body">
                                <h4 class="card-title"><strong>Open an Account</strong></h4>
                                <p class="card-text text-muted fw-light">Open a TN CyberTech Bank account</p>
                                <br>
                                <button class="ui purple right floated  button" @click="openAccount()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                     <div class="col-sm-6 mb-3">
                        <div class="card card-shadow">
                            <div class="card-body">
                                <h4 class="card-title"><strong>Upgrade iSave Account</strong></h4>
                                <p class="card-text text-muted fw-light">Update your low kyc account for more flexible business conditions</p>
                                <button class="ui purple right floated button" @click="iSaveUpgrade()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <div class="card card-shadow">
                            <div class="card-body">
                                <h4 class="card-title"><strong>View Applications</strong></h4>
                                <p class="card-text text-muted fw-light">View existing applications and make changes
                                    where necessary</p>
                                <button class="ui purple right floated button" @click="viewAccountApplications()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5">
                    <button @click="back()" class="ui grey button fluid">Back</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import {utils} from "@/utils/utils";
import {URLS} from "@/utils/constants";
import { useAuthStore } from '@/stores/auth';
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
    name: "HomeOptions",
    setup() {
        const authStore = useAuthStore();
        const accountOpeningStore = useAccountOpeningStore();
        return { authStore, accountOpeningStore };
    },
    data() {
        return { count: 0};
    },
    computed: {
        userId() { return this.authStore.userId; },
    },
    mounted() {
        this.getToken();
    },
    methods: {
        getUser() {
            this.get(URLS.getUser, true).then((res) => {
                console.log(res);
                this.setPhone(res.body.phone);
            })
                .catch(e => {
                    utils.logger(e);
                    this.$router.push("/account-opening/login");
                });
        },
        getToken() {
            if (this.$route.params.token !== null && typeof this.$route.params.token !== 'undefined') {
                console.log(this.$route.params.token);
                this.setAccessToken(this.$route.params.token);
                this.getActiveAccounts();
            }
        },
      getActiveAccounts() {
        this.get_sso_no_auth(URLS.sso_accounts + '/active-accounts/' + this.userId).then((res) => {
          console.log(res);
          const accountTypes = res.body.accounts.map(account => ({
            accountType: account.account_type,
            currencyType: account.currency
          }));

          this.setActiveAccountTypes(accountTypes);
        })
      },
        back() {
            this.$router.push("/account-opening/login");

        },
        openAccount() {
            this.$router.push("/account-opening/terms-and-conditions");
        },
        viewAccountApplications() {
            this.$router.push("/account-opening/view-account-applications");
        },
        iSaveUpgrade() {
            this.$router.push("/account-opening/iSave-list");
        },
        submitForm() {
        },
        setPhone(phone) { this.authStore.setPhone(phone); },
        setAccessToken(token) { this.authStore.setAccessToken(token); },
        setActiveAccountTypes(types) { this.accountOpeningStore.setActiveAccountTypes(types); },
        ...baseMethods,
    }
};
</script>